import Header from './components/Header';
import Actions from './components/Actions';
import General from './components/sections/general/General';
import Professional from './components/sections/Professional';
import Academic from './components/sections/Academic';
import Interests from './components/sections/Interests';
import Credentials from './components/sections/Credentials';
import Form from './hooks/Form';
import { getPrivacyUrlByCountry } from './utils/formHelpers';

const CreateAccountForm = (props) => {
  const vm = Form(props);

  const sectionEditable = !vm.user && !vm.loading && !vm.notEditor;
  const privacy = getPrivacyUrlByCountry(vm.formDataUser.country, vm.countries);
  const identificationConfirmed = (
    vm.formDataUser.identificationNumber.trim() ===
    vm.formDataUser.confirmIdentificationNumber.trim()
  );

  return (
    <div className="profile-edit-form w-full max-w-3xl mx-auto bg-white border border-gray-200 shadow-sm rounded-lg p-4 sm:p-6 md:p-8">
      <Header
        mode={props.mode}
        userlogin={props.userlogin}
        canAssignRole={vm.canAssignRole}
        roles={vm.roles}
        formDataUser={vm.formDataUser}
        handleChange={vm.handleChange}
        loading={vm.loading}
        notEditor={vm.notEditor}
      />
      <form onSubmit={vm.handleSubmit} className="space-y-6" autoComplete="off">
        <General
          open={vm.openAcc.general}
          onToggle={() => vm.toggleAcc('general')}
          editable={sectionEditable}
          formDataUser={vm.formDataUser}
          handleChange={vm.handleChange}
          handleCityChange={vm.handleCityChange}
          typeIds={vm.typeIds}
          countries={vm.countries}
          cities={vm.cities}
          mode={props.mode}
          loading={vm.loading}
        />
        {vm.formDataUser.stage === 'Profesional' && (
          <Professional
            open={vm.openAcc.profesional}
            onToggle={() => vm.toggleAcc('profesional')}
            editable={sectionEditable}
            formDataProfesional={vm.formDataProfesional}
            handleChange={vm.handleChange}
          />
        )}
        {vm.formDataUser.stage === 'Estudiante' && (
          <Academic
            open={vm.openAcc.academica}
            onToggle={() => vm.toggleAcc('academica')}
            editable={sectionEditable}
            formDataEstudiante={vm.formDataEstudiante}
            handleChange={vm.handleChange}
          />
        )}
        <Interests
          open={vm.openAcc.interes}
          onToggle={() => vm.toggleAcc('interes')}
          editable={sectionEditable}
          thematicAreas={vm.thematicAreas}
          formDataArea={vm.formDataArea}
          motivations={vm.motivations}
          formDataUser={vm.formDataUser}
          handleChange={vm.handleChange}
        />
        {props.mode === 'create' && (
          <Credentials
            open={vm.openAcc.credenciales}
            onToggle={() => vm.toggleAcc('credenciales')}
            editable={sectionEditable}
            formDataUser={vm.formDataUser}
            handleChange={vm.handleChange}
            acceptedPolicy={vm.acceptedPolicy}
            validPolicy={vm.validPolicy}
            loading={vm.loading}
            privacyUrl={privacy.url}
            privacyLabel={privacy.label}
          />
        )}
        <Actions
          mode={props.mode}
          user={vm.user}
          notEditor={vm.notEditor}
          loading={vm.loading}
          acceptedPolicy={vm.acceptedPolicy}
          identificationConfirmed={identificationConfirmed}
          onBackToLogin={props.onBackToLogin}
          onClose={props.onClose}
          modified={vm.modified}
          desModified={vm.desModified}
        />
      </form>
    </div>
  );
};

export default CreateAccountForm;
